import {Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { NavigationParameters } from '../models/navigationParameters';
import { PortalParameters } from '../models/portalParameters';
import { ResourceLinks } from '../models/resourceLinks';
import { WaitlistService } from '../services/waitlist.service';
import { ActivatedRoute } from '@angular/router';
import { trigger, transition, style, animate} from '@angular/animations';


@Component({
    selector: 'app-announcement',
    templateUrl: './announcement.component.html' ,
    styleUrls: ['./announcement.component.scss'],
    animations: [
        trigger('fade', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('400ms ease-in', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                animate('400ms ease-out', style({ opacity: 0 }))
            ])
        ])
    ]
})

export class AnnouncementComponent implements OnInit{
    navigationParams:NavigationParameters = new NavigationParameters();
    announcement:ResourceLinks = new ResourceLinks();
    announcements:ResourceLinks[] = [];
    resourceID:number;
    currentIndex = 0;
    intervalId!: any;

    constructor(
        private spinnerService: NgxSpinnerService,
        private waitlistService:WaitlistService,
        private router:Router,
        private activatedRoute:ActivatedRoute
    ) {}
    


    ngOnInit(){
        let params:PortalParameters = new PortalParameters();
        this.resourceID = +this.activatedRoute.snapshot.queryParamMap.get('resourceId');

        params.category = "Announcements";
        this.waitlistService.getResourceLinks(params)
        .subscribe(a =>{
            this.announcements = a;
            this.announcement = a.find(r =>r.resourceID == this.resourceID);
            this.startRotation();
        });
    }


    startRotation() {
    this.intervalId = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.announcements.length;
    }, 5000); // rotate every 5 seconds
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  goTo(index: number) {
    this.currentIndex = index;
  }

}